/**
 * Registro de deep links: URLs públicas que redirigen a una página
 * o a una página + acción (por ejemplo, Tomar carga).
 *
 * Cómo agregar uno nuevo:
 * 1. Si hace falta, sumá la acción en DEEP_LINK_ACTIONS.
 * 2. Agregá una entrada en deepLinks.
 * 3. En la página destino, usá useDeepLinkAction(DEEP_LINK_ACTIONS.X)
 *    para ejecutar la acción cuando llegue el usuario.
 *
 * Campos:
 * - path: URL que recibe el usuario (params de react-router, ej. :loadId)
 * - targetPath: ruta real de la app a la que se redirige
 * - action: acción a ejecutar en el destino; null = solo navegar
 * - getPayload: arma el payload a partir de params y location
 */

export const DEEP_LINK_ACTIONS = {
  TAKE_LOAD: 'TAKE_LOAD',
};

export const deepLinks = [
  {
    path: '/load/:loadId',
    targetPath: '/carrier',
    action: DEEP_LINK_ACTIONS.TAKE_LOAD,
    getPayload: (params, location) => ({
      loadId: params.loadId,
      assignedByUserId: new URLSearchParams(location?.search || '').get('assignedBy') || null,
    }),
  },
];
